<template>
  <section class="card_style">
    <div class="main_header_style">
      <h4>{{ $t("add_nation") }}</h4>
    </div>
    <form class="form_topic" @submit.prevent="addNation()">
      <div class="row">
        <!-- start input group -->
        <div class="col-12 col-lg-12">
          <div class="input-group">
            <label class="form-label"> {{ $t("name_en") }} (EN)</label>
            <input
              type="text"
              class="form-control"
              :placeholder="$t('name_en')"
              v-model="title_en"
              required
            />
          </div>
        </div>
        <!-- finish input group -->
        <!-- start input group -->
        <div class="col-12 col-lg-12">
          <div class="input-group">
            <label class="form-label"> {{ $t("name_en") }} (AR)</label>
            <input
              type="text"
              class="form-control"
              :placeholder="$t('name_en')"
              v-model="title_ar"
              required
            />
          </div>
        </div>
        <!-- finish input group -->

        <!-- start input group -->
        <div class="col-12">
          <button type="submit" class="btn PrimaryButton w-25">
            {{ $t("add") }}
          </button>
        </div>
        <!-- finish input group -->
      </div>
    </form>
  </section>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: "add-expness",
  data() {
    return {
      title_en: "",
      title_ar: "",
    };
  },
  methods: {
    async addNation() {
      const formData = new FormData();
      formData.append("title_en", this.title_en);
      formData.append("title_ar", this.title_ar);
      axios
        .post("/nationalities", formData)
        .then((response) => {
          Swal.fire({
            title: "",
            text: response.data.message,
            icon: "success",
          });
          this.$router.push("/nationality");
        })
        .catch((error) => {
          Swal.fire({
            title: "",
            text: error.response.data.message,
            icon: "error",
          });
        });
    },
  },
  created() {
    localStorage.removeItem("flightData");
    localStorage.removeItem("flightTrips");
    localStorage.removeItem("bookDataFlight");
    localStorage.removeItem("bookDetails");
    localStorage.removeItem("hotelData");
    localStorage.removeItem("bookData");
  }
};
</script>
<style lang="scss" scoped>
@import "./_nationality.scss";
</style>
